import { GridFooterWebComponent } from './component/GridFooterWebComponent';
import { WEB_COMPONENT_GRID_FOOTER } from '../../webcomponents.constants';

export { GridFooterWebComponent };

window.customElements.define(WEB_COMPONENT_GRID_FOOTER, GridFooterWebComponent);
